import { Injectable } from '@angular/core';

import { WorkflowAction } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { WorkflowActionPresenterModel } from '@osos/shared/types';
import { WorkflowActionParserService } from '../../parsers/workflow-action-parser/workflow-action-parser.service';

@Injectable()
export class WorkflowActionFactoryService extends FactoryBase<
  WorkflowAction,
  WorkflowActionPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: WorkflowActionParserService,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: WorkflowActionPresenterModel): WorkflowAction {
    //@TODO use presenter.specificationVersion
    const parser = this.getParser(WorkflowAction, WorkflowActionPresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(model: WorkflowAction): WorkflowActionPresenterModel {
    //@TODO use model.specificationVersion
    const parser = this.getParser(WorkflowAction, WorkflowActionPresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
}
